import axios from "axios";

const loaddata = async (url, options) => {
  try {
    const response = await axios({
      url,
      method: options.method,
      headers: options.headers,
      data: options.body,
    });
    return response.data;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const CallApiFormData = async (method, apiPath, params) => {
  let token = localStorage.getItem("token");

  let options = {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: params,
  };

  return loaddata(`${apiPath}?token=${token}`, options);
};

export const CallApiWithReferral = async (method, apiPath, params) => {
  let ReferralCode = localStorage.getItem("ReferralCode");

  let options = {
    method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: { ...params, ReferralCode },
  };

  return loaddata(apiPath, options);
};

export const CallApi_Without_Token = async (method, apiPath, params) => {
  let options = {
    method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: params,
  };

  return loaddata(apiPath, options);
};

export const CallApiWithToken = async (method, apiPath, params) => {
  let token = localStorage.getItem("Acess_Token");

  let options = {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(params),
  };

  return loaddata(`${apiPath}?token=${token}`, options);
};

export const CallApiFormEncoded = async (method, apiPath, params) => {
  let token = localStorage.getItem("token");

  const formBody = new URLSearchParams(params).toString();

  let options = {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: formBody,
  };

  return loaddata(`${apiPath}?token=${token}`, options);
};

export const callTokenApi = async () => {

  const response = await CallApiFormEncoded(
    "POST",
    "https://pwa.allislandfence.com/backend/token.php"
  );

  localStorage.setItem("Acess_Token", response.access_token);
};
